import { Http } from "../axios/interceptors";

export const allMovementTypes = async () =>
  Http("GET", `/Inventory/MovementTypes`);

export const createInventoryMovements = async (body) =>
  Http("POST", "/Inventory/Movements", null, body);

export const allInventoryMovements = async (param) =>
  Http("GET", `/Inventory/Movements?`, param);

export const getInventoryMovement = async (guid) =>
  Http("GET", `/Inventory/Movements/${guid}`);

export const getInventoryProductKardex = async (guidProduct, param) =>
  Http("GET", `/Inventory/Products/${guidProduct}/Kardex?`, param);

export const getInventoryMovements = getInventoryMovement;

export const getInventoryProducts = getInventoryProductKardex;
